import Vue from "vue"
import { MutationTree } from "vuex"

import {
  AvailabilitiesFilter,
  AvailabilityResource,
  AvailabilitiesState,
  Availability
} from "~/store/availabilities/availabilities.types"

import { RequestParameters } from "~/utils/SohoApi/SohoApi";
import { extractResourceIds, filterId } from "~/utils/store";

interface AvailabilitiesMutation {
  params: RequestParameters<Availability, AvailabilitiesFilter>
  data: AvailabilityResource[]
}

const mutations: MutationTree<AvailabilitiesState> = {
  SET_AVAILABILITY (state, resource: AvailabilityResource)  {
    const { id } = resource

    Vue.set(state.data, id, resource)
  },

  SET_AVAILABILITIES (state, { params, data }: AvailabilitiesMutation) {
    if (data && data.length <= 0) {
      return
    }

    data.forEach(resource => Vue.set(state.data, resource.id, resource))

    const id = filterId(params)

    Vue.set(state.filters, id, extractResourceIds(data))
  },

  DELETE_AVAILABILITIES (state) {
    Vue.set(state, 'data', {})
  }
}

export default mutations
